module.exports = __webpack_public_path__ + "static/media/cd_music.5196d581.ico";